export const MODULE_PERMISSIONS = {
    SIMULATOR: 'simulator',
    TRAVEL_REPORTS: 'travel-reports',
    EMPLOYEES: 'employees',
    ITINERARIES: 'itineraries',
    PROPOSALS: 'proposals',
    BO_BENEFITS: 'bo-benefits'
}